import config from './config';

__webpack_public_path__ = config.publicPath;
